import type { ReactNode } from 'react';

export const symbol_picture_in_picture_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M736-443q18.75 0 31.88-13.13Q781-469.25 781-488v-167q0-18.75-13.12-31.88Q754.75-700 736-700H476q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h245v137H615q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.5 21.32T615-443h121Zm114.18 245q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-512H308q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T308-800h512q24 0 42 18t18 42v512q0 15-9.32 22.5t-20.5 7.5ZM563-483Zm-166 6ZM792-82.97 714-160H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h20l60 60h-80v520h514L47-827q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l745 745q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-82.97Z"
		/>
	</svg>
);
